module.exports = __webpack_public_path__ + "static/media/cq_messaggi_segna_tutti_come_letti.27df777d.svg";